<template>
  <div class="off-bckgr-container-full">
    <my-header
      :page_name="$t('navigation.headerTitles.singleTask')"
      show_usermenu
    ></my-header>
    <el-dialog
      :visible.sync="formOpen"
      v-if="formOpen"
      center
      :title="taskSelected.caption"
      @close="onDialogClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <run-task-form
        :taskSelected="taskSelected"
        :autoDownload="autoDownload"
        @close="onDialogClose"
        :fromCron="false"
      ></run-task-form>
    </el-dialog>
    <el-dialog :visible.sync="fileUploadOpen" v-if="fileUploadOpen">
      <el-upload
        v-if="!resultAupgLine"
        action
        ref="upload"
        :auto-upload="false"
        :limit="1"
        accept=".aupg"
      >
        <el-button slot="trigger">{{ $t("runTask.fileSelect") }}</el-button>
      </el-upload>
      <div v-else :class="resultLineClass">
        {{ $t("runTask.result") + ":" + " " + resultAupgLine }}
        <div>
          {{
            $t("runTask.forMoreDetailsAboutValueLookConsole") +
            " (F12/Ctrl+Shift+K)"
          }}
        </div>
      </div>
      <div class="bottom-buttons">
        <div></div>
        <div v-if="!resultAupgLine">
          <el-button type="plain" @click="cancelUpload">{{
            $t("runTask.cancel")
          }}</el-button>
          <el-button type="primary" @click="uploadClick">ОК</el-button>
        </div>
        <div v-else>
          <el-button type="plain" @click="cancelUpload">{{
            $t("runTask.exit")
          }}</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="settings-line">
      <div style="display: flex">
        <div class="settings-element">
          <label>{{ $t("runTask.server") + ":" }}</label>
          <el-select
            v-model="serverSelected"
            @change="serverChanged"
            filterable
          >
            <el-option
              v-for="(server, index) in getServersArray"
              :key="index"
              :value="server.id"
              :label="server.name"
            ></el-option>
          </el-select>
        </div>
        <div class="settings-element">
          <label>{{ $t("runTask.app") + ":" }}</label>
          <el-select v-model="appSelected" @change="appChanged" filterable style="width:300px">
            <el-option
              v-for="(app, index) in getAppsArray"
              :key="index"
              :value="app.id"
              :label="app.alias?app.name+' ('+app.alias+')':app.name"
            ></el-option>
          </el-select>
        </div>
        <div class="settings-element">
          <el-checkbox v-model="autoDownload" @change="autoDownloadChanged">{{
            $t("runTask.autoLoading")
          }}</el-checkbox>
        </div>
      </div>
      <div
        class="settings-element"
        v-if="getUser && (getUser.roleid === '0' || getUser.roleid === '1')"
      >
        <el-button @click="baseUpgradeClick" class="aupg-button"
          >aupg</el-button
        >
      </div>
    </div>
    <!-- <el-button @click="errorClick">debug</el-button> -->

    <div class="main-transfer" v-if="getRTTasks && appSelected">
      <el-row type="flex" class="row-bg" justify="space-around">
        <el-col :span="11">
          <el-card class="box-card">
            <div slot="header" class="clearfix header">
              <span>{{ $t("runTask.administration") }}</span>
            </div>
            <div class="main-content list">
              <div
                v-for="task in getRTTasksByType.updateArray"
                :key="task.idTask"
                class="list-item task-element"
                style="font-weight: 500"
                :class="{'disabled-task': task.taskRight === '0'}"
                @click="taskClicked(task)"
              >
                <span class="task-element-label">{{ task.caption }}</span>
              </div>
              <div
                v-for="(task, index) in getRTTasksByType.adminArray"
                :key="index"
                class="list-item task-element"
                :class="{'disabled-task': task.taskRight === '0'}"
                @click="taskClicked(task)"
              >
                <span class="task-element-label">{{ task.caption }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="11">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t("runTask.appliedTasks") }}</span>
            </div>
            <div class="main-content list">
              <div
                v-for="(task, index) in getRTTasksByType.appliedTaskArray"
                :key="index"
                class="task-element"
                :class="{'disabled-task': task.taskRight === '0'}"
                @click="taskClicked(task)"
              >
                <span class="task-element-label">{{ task.caption }}</span>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <task-status></task-status>
    </div>
  </div>
</template>


<script>
import Header from "../../components/reusable/header/Header";
import RunTaskForm from "../../components/tasks/RunTaskForm";
import TaskStatus from "../../components/tasks/TaskStatus";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      serverSelected: null,
      appSelected: null,
      taskSelected: null,
      formOpen: false,
      formData: [],
      fileUploadOpen: false,
      resultAupgLine: "",
      resultLineClass: "",
      autoDownload: false,
    };
  },
  created() {
    if(!this.getUser) return null;
    this.$store
      .dispatch("getServers", this.getUser.roletype === "1"|| +this.getUser.roleid > 1)
      .then(() => {
        let savedData = JSON.parse(this.$localStorage.get("wa-runTask"));
        if (!!savedData && savedData.server && savedData.app) {
          this.$store.commit("setLoading", true);
          if (savedData.autoDownload) {
            this.autoDownload = savedData.autoDownload;
          }
          if (
            !this.getServersArray.find((serv) => serv.id === savedData.server)
          ) {
            this.$store.commit("setLoading", false);
            return;
          }
          this.serverSelected = savedData.server;
          this.$store
            .dispatch("getApps", {
              serverSelected: this.serverSelected,
              specialUser: this.getUser.roletype === "1" || +this.getUser.roleid > 1,
            })
            .then(() => {
              if (!this.getAppsArray.find((app) => app.id === savedData.app)) {
                return;
              }
              this.appSelected = savedData.app;
              return this.$store.dispatch("getLink", this.appSelected);
            })
            .then(() => {
              return this.$store.dispatch("getInfo", {
                id: this.appSelected,
                getFn: "getSectionInfo",
              });
            })
            .then(() => {
              this.$store.commit("setLoading", false);
            })
            .catch(() => {
              this.$store.commit("setLoading", false);
            });
        }
      })
      .catch((err) => {
        console.error(err);
        if (err === "Access denied") {
          this.serverSelected = null;
          this.appSelected = null;
          this.$store.commit("setAppsArray", []);
        }
      });
  },
  methods: {
    errorClick() {
      // this.$store.commit("setError", "Это ошибка ");
      this.$store.commit(
        "setError",
        `{[${this.$t("runTask.itsMistake")} {[${this.$t(
          "runTask.shortMessage"
        )}]}]}`
      );
    },
    serverChanged() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getApps", {
          serverSelected: this.serverSelected,
          specialUser: this.getUser.roletype === "1" || +this.getUser.roleid > 1,
        })
        .then(() => {
          if(this.getAppsArray && this.getAppsArray.length === 0){
            this.appSelected = null;
            throw new Error("Access denied");
          }
          this.appSelected = null;
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          this.$store.commit("setLoading", false);
          console.error(err);
        });
    },
    appChanged() {
      //get sections tasks by users roles
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getLink", this.appSelected)
        .then(() => {
          return this.$store.dispatch("getInfo", {
            id: this.appSelected,
            getFn: "getSectionInfo",
          });
        })
        .then(() => {
          let object = {
            server: this.serverSelected,
            app: this.appSelected,
            autoDownload: this.autoDownload,
          };
          this.$localStorage.set("wa-runTask", JSON.stringify(object));
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          this.$store.commit("setLoading", false);
          console.error(err);
        });
    },
    taskClicked(value) {
      if(value.taskRight !== "1"){
        return;
      }
      this.$store.commit("setLoading", true);
      this.taskSelected = value;
      //console.log("taskSelected: ", this.taskSelected);
      //информация о текущем приложении (для пути и другой информации)
      this.$store
        .dispatch("getInfo", {
          id: this.appSelected,
          getFn: "getSectionInfo",
        })
        .then(() => {
          return this.$store.dispatch("getBasesSection", this.appSelected);
        })
        .then(() => {
          if (value.idTypeTask !== "99")
            this.$store.dispatch("getCmdLine", value.idTask).then(() => {
              this.formOpen = true;
            });
          else this.formOpen = true;
        })
        .then(() => {
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          this.$store.commit("setLoading", false);
          console.error(err);
        });
    },
    onDialogClose() {
      this.formOpen = false;
      this.$store.commit("setRetFile", null);
    },
    baseUpgradeClick() {
      this.fileUploadOpen = true;
    },
    uploadClick() {
      this.$store.commit("setLoading", true);
      let file = this.$refs.upload.uploadFiles[0].raw;
      this.$store
        .dispatch("uploadAupgFile", file)
        .then((result) => {
          this.$store.commit("setLoading", false);
          this.resultAupgLine = result;
          this.resultLineClass = "success";
        })
        .catch((error) => {
          this.$store.commit("setLoading", false);
          this.resultAupgLine = error;
          this.resultLineClass = "error";
        });
    },
    cancelUpload() {
      this.fileUploadOpen = false;
      this.resultAupgLine = "";
      this.resultLineClass = "";
      this.$message(this.$t("runTask.plsRefreshPage"));
    },
    autoDownloadChanged(value) {
      let object = {
        server: this.serverSelected,
        app: this.appSelected,
        autoDownload: value,
      };
      this.$localStorage.set("wa-runTask", JSON.stringify(object));
    },
  },
  computed: {
    ...mapGetters([
      "getServersArray",
      "getAppsArray",
      "getExistBases",
      "getRTTasks",
      "getRTTasksByType",
      "getRTCmdLine",
      "getCurInfo",
      "getUser",
    ]),
  },
  components: {
    myHeader: Header,
    RunTaskForm,
    TaskStatus,
  },
};
</script>

<style scoped>
.main-runtask {
  background: var(--main-background);
}
.settings-line {
  justify-content: space-between;
}
.task-section {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.task-section-element {
  border: 2px solid var(--main-background);
  /* border-top: 2px solid var(--main-background);
  border-right: 2px solid var(--main-background); */
  padding: 10px 20px;
  margin: 10px 10px;
  width: calc((100% - var(--nav-left-small)) / 2);
}
.task-section-element-name {
  margin: 5px;
  text-align: center;
}
.task-element {
  margin: 4px 0;
  margin-left: 10px;
  text-indent: -10px;
  cursor: pointer;
  /* font-weight: 500; */
}
.task-element::before {
  content: "\26AC";
  margin-right: 3px;
  color: var(--active-color);
}
.task-element.disabled-task{
  cursor:not-allowed;
  color: rgb(190, 190, 190);
  font-weight: 400;
}
.task-element.disabled-task .task-element-label:hover{
  color: rgb(190, 190, 190);
  text-decoration-line: none;
}
.task-element-label {
  padding-bottom: 5px;
}
.task-element-label:hover {
  color: var(--active-color);
  text-decoration-line: underline;
  text-decoration-color: var(--active-color);
}
.box-card {
  margin-bottom: 1em;
}
.list {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  scrollbar-color: grey lightgrey;
  scrollbar-width: auto;
}
.clearfix {
  text-align: center;
  color: white;
}
.el-card.box-card .el-card__header {
  background-color: var(--active-color) !important;
}
.main-content {
  height: 60vh;
  display: flex;
  flex-direction: column;
}

.list::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.list::-webkit-scrollbar-track {
  background-color: lightgrey;
}

.list::-webkit-scrollbar-thumb {
  background-color: grey;
}
.el-col {
  margin-top: 10px;
}
.main-transfer {
  background: var(--main-background);
  padding-bottom: 5px;
  margin-top: -9px;
}
.success {
  color: darkgreen;
}
.error {
  color: red;
  font-weight: 500;
}
.aupg-button {
  transform: scale(0.7);
}
</style>